module.exports = __webpack_public_path__ + "img/book-bg-1.8790bba6.png";